import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import generalStyles from './style/general.css';

export default function CardAction({ children, isActive, onClick, href }) {
  const buttonClasses = cx(generalStyles.button, {
    [generalStyles.buttonDefault]: !isActive,
    [generalStyles.buttonActive]: isActive,
  });

  const Tag = href ? 'a' : 'div';
  const tagProps = href || onClick;

  return (
    <Tag {...tagProps} className={buttonClasses}>
      {children}
    </Tag>
  );
}

CardAction.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-card/CardAction/index.js